import { useTranslation } from "react-i18next";
import NavigationBar from "../components/layout/NavigationBar";

const EventNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper" style={{ height: "100vh" }}>
      <NavigationBar />
      <div className="main">
        <header className="section _60">
          <div className="container hero-center realisa">
            <div className="pad-15">
              <h1 className="heading-9vw">{t("pages.notFound.title")}</h1>
            </div>
            <h2 className="made-28">{t("pages.notFound.subtitle")}</h2>
          </div>
        </header>
      </div>
    </div>
  );
};

export default EventNotFound;
